import React, {Component} from 'react';
//import PopularForm from './form';
import PopularForm from './form';
import {addPopularStoreItem} from '../../modules/Api';
import {normalizer} from './pipeline';
import {notification} from 'antd';
import history from '../../modules/History';

export default class AddPopularStores extends Component {
    constructor() {
        super();
        this.state = {
            data: {},
            submitted: false
        }
        
    }
    submit(values) {
        if(this.state.submitted){
            return;
        }
        this.setState({submitted: true});
        const formData = normalizer(values);
        addPopularStoreItem(formData, () => {
            notification.open({
                message: `فروشگاه محبوب اضافه شد.!`,
                description: `در صورت نیاز میتوانید با درگ دراپ کردن جای فروشگاه را تغییر دهید.`
            });
            this.setState({submitted: false});
            history.item.push(`/popularstores`);
        });
    }
    render() {
        return (
            <div><PopularForm initialData={this.state.data} submit={this.submit.bind(this)} submitted={this.state.submitted}/></div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/containers/PopularStores/add.js